import {
    callLogsPatientURL,
    callLogsURL,
    callLogsViewUpdateURL,
    getAllCommunicationLogsUrl,
    getCallLogWithFileId,
    getMediaWithPatientId,
    getSassCallURL,
    getTwilioLogsURL,
    inboundCallLogsURL,
    inpersonViewUpdateURL,
    insertSaasCallURL,
    marketingSMSsentURL,
    marketingsmsURL,
    outboundCallLogsURL,
    sendSmsToPatientURL,
    transcriptsURL,
    updatedCallLogsURL,
    updateSaasCallURL,
} from "../../apiEndPoints"
import {
    updateCallLogs,
    // fetchInboundCalls,
    // fetchOutboundCalls,
    updateCallHistory,
    updateLoading,
    updateCallIsViewed,
    updateAptCallIsViewed,
    updateCommunicationHistory,
} from "./callogSlice"
import { axiosGet, axiosPost, axiosPut } from "../../utilities/axiosRequest"
import { logTransaction } from "../appActions"
import moment from "moment"

export function getAllCommunicationLogs(patientId, success, failure) {
    return function (dispatch, getState) {
        let url = `${getAllCommunicationLogsUrl}?patientId=${patientId}`

        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        response.data.responseData,
                        "sdfljsldfjsdlfjdlskf"
                    )
                    let data = response.data.responseData
                    let communicationHistory = [
                        ...(data?.emailLogs || []),
                        ...(data?.inpersonLogs || []),
                        ...(data?.smslogs || []),
                        ...(data?.callLogs || []),
                    ]
                    dispatch(updateCommunicationHistory(communicationHistory))
                    success && success(response.data.responseData)
                } else {
                    dispatch(updateCommunicationHistory([]))
                    success && success([])
                }
            })
            .catch(err => {
                dispatch(updateCommunicationHistory([]))
                failure && failure()
            })
            .finally(() => {
                // dispatch(updateCommunicationHistory([]))
                // failure && failure()
            })
    }
}

export function fetchPatientCallLogs(patientId, success) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosGet(
            callLogsPatientURL +
                `?patientUserId=${patientId}&isCall="careCall"&programId=${program.id}`
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Fetch Call Logs", response))
                    dispatch(updateCallHistory(response.data.responseData))
                    success && success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Fetch Call Logs Error", response))
                    dispatch(updateCallHistory([]))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Call Logs Failure", err))
                dispatch(updateCallHistory([]))
            })
    }
}

export function updateTelehealthViewed(id, success, failure) {
    return function (dispatch, getState) {
        axiosPut(callLogsViewUpdateURL + `/${id}?summaryViewTrue=true`)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Update Call Log", response))
                    success && success()
                } else {
                    dispatch(logTransaction("Update Call Log Error", response))
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Update Call Log Failure", err))
                failure && failure()
            })
    }
}

export function fetchPatientCallIsViewed(patientId, success) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosGet(
            callLogsPatientURL +
                `?patientUserId=${patientId}&isCall="careCall"&programId=${program.id}`
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Fetch Call Logs", response))
                    dispatch(updateCallIsViewed(response.data.responseData))
                    success && success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Fetch Call Logs Error", response))
                    dispatch(updateCallIsViewed([]))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Call Logs Failure", err))
                dispatch(updateCallIsViewed([]))
            })
    }
}

export function fetchPatientAptCallLogs(patientId, success) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosGet(
            callLogsPatientURL +
                `?patientUserId=${patientId}&isCall="appointmentCall"&programId=${program.id}`
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Fetch Call Logs", response))
                    dispatch(updateCallHistory(response.data.responseData))
                    success && success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Fetch Call Logs Error", response))
                    dispatch(updateCallHistory([]))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Call Logs Failure", err))
                dispatch(updateCallHistory([]))
            })
    }
}
export function fetchPatientAptCallIsViewed(patientId, success) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosGet(
            callLogsPatientURL +
                `?patientUserId=${patientId}&isCall="appointmentCall"&programId=${program.id}`
        )
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Fetch Call Logs", response))
                    dispatch(updateAptCallIsViewed(response.data.responseData))
                    success && success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Fetch Call Logs Error", response))
                    dispatch(updateAptCallIsViewed([]))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Call Logs Failure", err))
                dispatch(updateAptCallIsViewed([]))
            })
    }
}

export function updateInpersonViewed(id, success, failure) {
    return function (dispatch, getState) {
        axiosPut(inpersonViewUpdateURL + `/${id}?summaryViewTrue=true`)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Update Call Log", response))
                    success && success()
                } else {
                    dispatch(logTransaction("Update Call Log Error", response))
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Update Call Log Failure", err))
                failure && failure()
            })
    }
}

// export function fetchInboundCallLogs(input, filterData, flag = false) {
//   return function (dispatch, getState) {
//     dispatch(updateLoading(true))
//     const currentDate = moment()
//     const startDateOfMonth = currentDate
//       .clone()
//       .startOf("month")
//       .format("YYYY-MM-DD")
//     const endDateOfMonth = currentDate
//       .clone()
//       .endOf("month")
//       .format("YYYY-MM-DD")
//     // const userProfileid = getState().login.userProfile.userId
//     let clinic = !getState().clinics.selectedClinic?.clinicId
//       ? getState().login.user?.clinicListForUser?.[0]?.clinicId
//       : getState().clinics.selectedClinic.clinicId
//     // console.log(clinic,"lkjhggfy")
//     //   let organisation = !getState().organisations.selectedOrg?.organizationId
//     //     ? getState().login.user?.organizationListForUser &&
//     //       getState().login.user?.organizationlistforuser?.[0]?.organizationId
//     //     : getState().organisations.selectedOrg.organizationId

//     //let url = inboundCallLogsURL + `?fromDate=${startDateOfMonth}&toDate=${endDateOfMonth}`
//     var url
//     if (flag) {
//       url =
//         updatedCallLogsURL +
//         `?fromDate=${filterData.startDate}&toDate=${filterData.endDate}&isInbound=true&clinicId=${input.clinic}`
//     } else {
//       url =
//         updatedCallLogsURL +
//         `?fromDate=${startDateOfMonth}&toDate=${endDateOfMonth}&isInbound=true&clinicId=${input.clinic}`
//     }
//     axiosGet(url)
//       .then(response => {
//         if (
//           response.data.responseData !== null &&
//           response.data.responseData.length > 0
//         ) {
//           dispatch(updateLoading(false))
//           dispatch(fetchInboundCalls(response.data.responseData))
//           dispatch(logTransaction("Fetch Performace Report", response))
//         } else {
//           dispatch(fetchInboundCalls([]))
//           dispatch(updateLoading(false))
//           dispatch(logTransaction("Fetch Performace Report Failed", response))
//         }
//       })
//       .catch(err => {
//         dispatch(fetchInboundCalls([]))
//         dispatch(updateLoading(false))
//         dispatch(logTransaction("Fetch Performace Report Failed", err))
//       })
//   }
// }

// export function fetchOutboundCallLogs(input, filterData, flag = false) {
//   return function (dispatch, getState) {
//     console.log(input, "hjweduehsrf")
//     dispatch(updateLoading(true))
//     const currentDate = moment()
//     // const userProfileid = getState().login.userProfile.userId
//     const startDateOfMonth = currentDate
//       .clone()
//       .startOf("month")
//       .format("YYYY-MM-DD")
//     const endDateOfMonth = currentDate
//       .clone()
//       .endOf("month")
//       .format("YYYY-MM-DD")
//     // let clinic = !getState().clinics.selectedClinic?.clinicId
//     //     ? getState().login.user?.clinicListForUser?.[0]?.clinicId
//     //     : getState().clinics.selectedClinic.clinicId
//     // console.log(clinic,"lkjhggfy")
//     //   let organisation = !getState().organisations.selectedOrg?.organizationId
//     //     ? getState().login.user?.organizationListForUser &&
//     //       getState().login.user?.organizationlistforuser?.[0]?.organizationId
//     //     : getState().organisations.selectedOrg.organizationId
//     var url
//     if (flag) {
//       url =
//         outboundCallLogsURL +
//         `?fromDate=${filterData.startDate}&toDate=${filterData.endDate}&clinicId=${input.clinic}`
//     } else {
//       url =
//         outboundCallLogsURL +
//         `?fromDate=${startDateOfMonth}&toDate=${endDateOfMonth}&clinicId=${input.clinic}`
//     }
//     // } catch(err) {
//     //   console.log(err, 'sdfjdslkfj')
//     // }
//     axiosGet(url)
//       .then(response => {
//         console.log(response, "hjweduehsrf")
//         if (
//           response.data.responseData !== null &&
//           response.data.responseData.length > 0
//         ) {
//           dispatch(updateLoading(false))
//           dispatch(fetchOutboundCalls(response.data.responseData))
//           dispatch(logTransaction("Fetch Performace Report", response))
//         } else {
//           dispatch(updateLoading(false))
//           dispatch(fetchOutboundCalls([]))
//           dispatch(logTransaction("Fetch Performace Report Failed", response))
//         }
//       })
//       .catch(err => {
//         dispatch(updateLoading(false))
//         dispatch(fetchOutboundCalls([]))
//         dispatch(logTransaction("Fetch Performace Report Failed", err))
//       })
//   }
// }

export function fetchTranscripts(pToId, success, failure) {
    return function (dispatch) {
        let url = transcriptsURL + `?toId=${pToId}`
        axiosGet(url)
            .then(response => {
                console.log(response, "hjweduehsrf")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData
                ) {
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Performace Report Failed", err))
                failure && failure()
            })
    }
}

export function newCallLogsUpdation(
    input,
    filterData,
    flag = false,
    success,
    failure
) {
    return function (dispatch, getState) {
        const currentDate = moment()
        dispatch(updateLoading(true))
        const startDateOfMonth = currentDate
            .clone()
            .startOf("month")
            .format("YYYY-MM-DD")
        const endDateOfMonth = currentDate
            .clone()
            .endOf("month")
            .format("YYYY-MM-DD")

        var url

        if (flag) {
            url =
                updatedCallLogsURL +
                `?fromDate=${filterData.startDate}&toDate=${filterData.endDate}&clinicId=${input.clinic}`
        } else {
            url =
                updatedCallLogsURL +
                `?fromDate=${startDateOfMonth}&toDate=${endDateOfMonth}&clinicId=${input.clinic}`
        }
        axiosGet(url)
            .then(response => {
                console.log(response, "hjweduehsrf")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    console.log(response.data.responseData, "jgugug")
                    dispatch(updateCallLogs(response.data.responseData))
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                    dispatch(updateLoading(false))
                    success && success(response.data.responseData)
                } else {
                    dispatch(updateCallLogs([]))
                    dispatch(updateLoading(false))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(updateCallLogs([]))
                dispatch(updateLoading(false))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
                failure && failure()
            })
    }
}

export function insertSaasCall(payload, success, failure) {
    return function (dispatch, getState) {
        const url = insertSaasCallURL
        axiosPost(url, payload)
            .then(response => {
                console.log(response, "hjweduehsrf")
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction("Saas call insert succcess", response)
                    )
                    success && success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction("Saas call insert Failed", response)
                    )
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Saas call insert Failed", err))
                failure && failure()
            })
    }
}

export function fetchMarketingCall(payload, success, failure) {
    return function (dispatch, getState) {
        let url =
            getSassCallURL +
            `?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}`
        if (payload?.startDate && payload?.endDate) {
            const { startDate, endDate } = payload
            url += `&fromDate=${startDate}&toDate=${endDate}`
        }
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction("Saas call fetch succcess", response)
                    )
                    success && success(response.data?.responseData || [])
                } else {
                    dispatch(logTransaction("Saas call fetch Failed", response))
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Saas call fetch Failed", err))
                failure && failure()
            })
    }
}

export function fetchMarketingCallCount(payload, success, failure) {
    return function (dispatch, getState) {
        let url = getSassCallURL + `?isCount=${true}`
        if (payload?.startDate && payload?.endDate) {
            const { startDate, endDate } = payload
            url += `&fromDate=${startDate}&toDate=${endDate}`
        }
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction("Saas call fetch succcess", response)
                    )
                    success && success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Saas call fetch Failed", response))
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Saas call fetch Failed", err))
                failure && failure()
            })
    }
}

export function fetchInboundCallsCount(payload, success, failure) {
    return function (dispatch, getState) {
        let url = inboundCallLogsURL + `?isCount=true`
        if (payload?.startDate && payload?.endDate) {
            const { startDate, endDate } = payload
            url += `&fromDate=${startDate}&toDate=${endDate}`
        }
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction("Saas call fetch succcess", response)
                    )
                    success && success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Saas call fetch Failed", response))
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Saas call fetch Failed", err))
                failure && failure()
            })
    }
}

export function fetchInboundCalls(payload, success, failure) {
    return function (dispatch, getState) {
        let url =
            inboundCallLogsURL +
            `?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&clinicId=${payload.clinicId}`
        if (payload?.startDate && payload?.endDate) {
            const { startDate, endDate } = payload
            url += `&fromDate=${startDate}&toDate=${endDate}`
        }
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction("Saas call fetch succcess", response)
                    )
                    success && success(response.data?.responseData || [])
                } else {
                    dispatch(logTransaction("Saas call fetch Failed", response))
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Saas call fetch Failed", err))
                failure && failure()
            })
    }
}

export function fetchOutboundCallsCount(payload, success, failure) {
    return function (dispatch, getState) {
        const program = getState().user.program
        console.log(program, "sdfkjdfjdlfjl")
        let url =
            outboundCallLogsURL +
            `?isCount=true&clinicId=${payload.clinicId}&programId=${program.id}`
        if (payload?.startDate && payload?.endDate) {
            const { startDate, endDate } = payload
            url += `&fromDate=${startDate}&toDate=${endDate}`
        }
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction("Saas call fetch succcess", response)
                    )
                    success && success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Saas call fetch Failed", response))
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Saas call fetch Failed", err))
                failure && failure()
            })
    }
}

export function fetchOutboundCalls(payload, success, failure) {
    return function (dispatch, getState) {
        const program = getState().user.program
        console.log(program, "sdfkjdfjdlfjl")
        let url =
            outboundCallLogsURL +
            `?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&clinicId=${payload.clinicId}&programId=${program.id}`
        if (payload?.startDate && payload?.endDate) {
            const { startDate, endDate } = payload
            url += `&fromDate=${startDate}&toDate=${endDate}`
        }
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction("Saas call fetch succcess", response)
                    )
                    success && success(response.data?.responseData || [])
                } else {
                    dispatch(logTransaction("Saas call fetch Failed", response))
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Saas call fetch Failed", err))
                failure && failure()
            })
    }
}

export function getTwilioLogs(payload, success, failure) {
    return function (dispatch, getState) {
        let url = getTwilioLogsURL + `?clinicId=${payload.clinicId}`
        if (payload?.startDate && payload?.endDate) {
            const { startDate, endDate } = payload
            url += `&fromDate=${startDate}&toDate=${endDate}`
        }
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction("Saas call fetch succcess", response)
                    )
                    success && success(response.data?.responseData || [])
                } else {
                    dispatch(logTransaction("Saas call fetch Failed", response))
                    failure && failure()
                }
            })
            .catch(err => {
                dispatch(logTransaction("Saas call fetch Failed", err))
                failure && failure()
            })
    }
}

export function updateSaasCall(callLogId, payload, success, failure) {
    return function (dispatch, getState) {
        // const callLogId = getState().callogs.callLogId
        const url = updateSaasCallURL + `/${getState().callogs.callLogId}`

        axiosPut(url, payload, { "Content-Type": "application/json" })
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    dispatch(logTransaction("Update call log", response))
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction("Update call log failure", response)
                    )
                    failure(response)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Update call log Failure", err))
                failure(err.message)
            })
    }
}

export function fetchMarketingSms(success, failure) {
    return function (dispatch, getState) {
        // const callLogId = getState().callogs.callLogId
        const url = marketingsmsURL + `?toPhone=${8176702347}`

        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    dispatch(
                        logTransaction("Fetch marketing sms success", response)
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction("Fetch marketing sms failure", response)
                    )
                    failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch marketing sms failure", err))
                failure(err.message)
            })
    }
}

export function fetchMarketingSmsSent(success, failure) {
    return function (dispatch, getState) {
        // const callLogId = getState().callogs.callLogId
        const url = marketingSMSsentURL + `?fromPhone=${8176702347}`

        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    dispatch(
                        logTransaction(
                            "Fetch marketing sms sent success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "Fetch marketing sms sent failure",
                            response
                        )
                    )
                    failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("Fetch marketing sms sent failure", err)
                )
                failure(err.message)
            })
    }
}

export function sendSMS(toPhone, msg, success, failure) {
    return function (dispatch, getState) {
        // const callLogId = getState().callogs.callLogId
        const url =
            sendSmsToPatientURL +
            `?toPhone=${toPhone}&message=${msg}&isMarketing=true`

        axiosPost(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(
                        logTransaction(
                            "send marketing sms sent success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "send marketing sms sent failure",
                            response
                        )
                    )
                    failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(logTransaction("send marketing sms sent failure", err))
                failure(err.message)
            })
    }
}
export function fetchCalllogByFileId(id, success) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosGet(getCallLogWithFileId + `?fileId=${id}`)
            .then(response => {
                console.log(response, success, "adefkhuasekgfigsaefiygwedf")
                if (response.data.statusCD === 200) {
                    success && success(response.data.responseData)
                } else {
                }
            })
            .catch(err => {
                console.log(err, "adefkhuasekgfigsaefiygwedf")
            })
    }
}

export function fetchMediabyFileId(id, success) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        axiosGet(getMediaWithPatientId + `?fileId=${id}`)
            .then(response => {
                console.log(response, success, "adefkhuasekgfigsaefiygwedf")
                if (response.data.statusCD === 200) {
                    success && success(response.data.responseData)
                } else {
                }
            })
            .catch(err => {
                console.log(err, "adefkhuasekgfigsaefiygwedf")
            })
    }
}
